import {
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Theme } from "@mui/system";
import React, { useState } from "react";
import { FilterDropdownCore } from "../../../common/components";
import { useDialogStyles } from "../../../common/components/modals/subscribe-dialog/SubscribeDialog";

interface SelectFilterProps {
  label?: string;
  options?: string[];
  onSave: (option: any) => any;
  defaultSelected: string;
}

export const SelectBids: React.FC<SelectFilterProps> = ({
  label,
  options,
  defaultSelected,
  onSave,
}) => {
  const [type, setType] = useState(defaultSelected);
  const dialogStyles = useDialogStyles();
  const isMd = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

  return (
    <Box display="flex" data-cy="bids-select">
      <FilterDropdownCore
        buttonLabel={
          <Box display="flex" alignItems="center">
            <Typography variant={isMd ? "body2" : "subtitle2"}>
              <span
                style={{
                  fontWeight: 600,
                }}
              >
                {label}:{" "}
              </span>
            </Typography>
            <Typography
              style={{
                color: "white",
              }}
              variant={isMd ? "body2" : "subtitle2"}
              px={2}
            >
              {type}
            </Typography>
          </Box>
        }
        onApply={() => onSave(type)}
      >
        <Box px={5}>
          <RadioGroup
            style={{
              display: "flex",
              flexDirection: "column",
            }}
            defaultValue={type}
            onChange={(e) => {
              setType(e.target.value);
            }}
          >
            {options?.map((option) => (
              <FormControlLabel
                key={option}
                data-cy={option}
                value={option}
                control={
                  <Radio className={dialogStyles.radio} disableTouchRipple />
                }
                label={
                  <Typography
                    color="secondary"
                    variant={isMd ? "body2" : "subtitle2"}
                  >
                    {option}
                  </Typography>
                }
              />
            ))}
          </RadioGroup>
        </Box>
      </FilterDropdownCore>
    </Box>
  );
};
